<template>
  
    <b-modal
      hide-footer
      v-model="showUserDeletor"
      @hidden="close"
      :title="$t('Delete Phone Number')">      
      <b-card >
        <h3>{{ $t('Confirmation before deletion') }}</h3>
        <p class="text-justify">
            {{ $t('This operation is irreversible.') }} 
        </p>
        <p>{{ $t('Please enter the phone number name ') }}<i>{{$store.state.user.notificationDeletorData ? $store.state.user.notificationDeletorData.phone : '???'}}</i>{{ $t(' to confirm the deletion') }}.</p>
        <validation-observer ref="observer" v-slot="{ handleSubmit }" >
          <b-form @submit.stop.prevent="handleSubmit(apply)">
            <validation-provider
              :name="$t('Confirmation')"
              :rules="{ required: true, is:$store.state.user.notificationDeletorData ? $store.state.user.notificationDeletorData.phone : '???' }"
              v-slot="validationContext"
            >
              <b-form-group
                label-cols-sm="3"
                :label="$t('Phone Number:')"
                label-align-sm="left"
                label-for="username"
              >
                <b-form-input
                  v-model="username"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-1-live-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            
                        
                <b-button  class="float-left" @click="close">
                    {{ $t('Cancel')}}
                </b-button>
                <b-button  :loading="requesting" variant="primary" class="float-right" type="submit">
                    {{ $t('Delete')}}
                </b-button>

          </b-form>
        </validation-observer>
      </b-card>
    </b-modal>  
</template>

<script>
import { AuthService } from '@/services/auth.service'
import { SPService } from "@/services/sp.service";
import { API_URL } from '@/.env'
export default  {
  components: {
    
  },  
  data() {
    return {
      showUserDeletor: false     ,
      requesting: false, 
      username: null,
    }
  },
  watch : {
    '$store.state.user.notificationDeletorShow': function(val) {        
        this.showUserDeletor = val     
        this.requesting = false
    }
  },    
  methods: {
        close() {           
            this.$store.commit('user/SHOW_NOTIFICATIONDELETOR',null);                        
        },
        getValidationState({ dirty, validated, valid = null }) {
          return dirty || validated ? valid : null;
        },
        async apply() {
          this.requesting = true
          let answer = await SPService.deleteUser(API_URL.url, this.$store.state.user.currentUser.jwt, this.$store.state.user.notificationDeletorData.oid)
          if(answer.status !== 200)
            this.$bvToast.toast( `${this.$t('Error deleting user')} ${this.$store.state.user.notificationDeletorData.username}`, {
              title: this.$t('Phone Number Management'),            
              solid: true,
              variant: 'warning',
              duration: 5000
            });
          else             
            this.$bvToast.toast( `${this.$t('Phone number')} ${this.$store.state.user.notificationDeletorData.phone} ${this.$t('is now deleted')}.`, {
              title: this.$t('Phone Number Management'),            
              solid: true,
              variant: 'success',
              duration: 5000
            });
          this.requesting = false;
          debugger
          this.$store.commit('user/SHOW_NOTIFICATIONDELETOR',null);
          this.$store.dispatch('fleet/loadUsers');
        }
    },
  mounted() {      
      this.$store.commit('user/SHOW_NOTIFICATIONDELETOR',null);
  },
  name: "NotificationDeletionModal"
}
</script>

<style lang="scss" scoped>

</style>
